

const Ecc = ({ boardLabel, existingBoardPosition }) => {
    return (
        <>

            <svg>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-532.000000, -514.000000)">
                        <g id="SLD/Infos/Microgrid_Background" transform="translate(532.000000, 514.000000)">
                            <rect
                                id="Rectangle-Copy-24"
                                stroke="var(--se-sld-circline)"
                                strokeWidth="3"
                                x={existingBoardPosition.x}
                                y={existingBoardPosition.y}
                                width={existingBoardPosition.width}
                                height={existingBoardPosition.height}
                                rx={existingBoardPosition.rx}
                            />
                            <text id="AAA" fontFamily="Nunito-Regular, Nunito" fontSize="18" fontWeight="normal" fill="var(--se-sld-circline)">
                                <tspan x={existingBoardPosition.labelX} y={existingBoardPosition.labelY}>{boardLabel}</tspan>
                            </text>

                        </g>
                    </g>
                </g>
            </svg>
        </>
    );
};

export default Ecc;
